import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/updates`;
const token = localStorage.getItem("token");

/// GET
// Fonction pour récupérer toutes les mises à jour : getAllUpdates
export const getAllUpdates = async () => {
  try {
    const response = await axios.get(`${apiUrl}/AllUpdates`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.data) {
      console.log("Réponse API :", response.data);
      return response.data; // ou response.data.data si votre API encapsule les données
    } else {
      console.error("Les données de l'API sont vides ou non définies.");
      return [];
    }
  } catch (error) {
    console.error("Erreur lors du chargement des mises à jour:", error);
    return []; // Renvoie un tableau vide en cas d'erreur
  }
};

/// POST
// Fonction pour ajouter une mise à jour : addUpdate
export const addUpdate = async (update) => {
  try {
    const response = await axios.post(`${apiUrl}/addUpdate`, update, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout du update:", error);
    return null;
  }
};

// Fonction pour récupérer une mise à jour par son ID : getUpdateById
export const getUpdateById = async (updateId) => {
  try {
    const response = await axios.get(`${apiUrl}/${updateId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération du update:", error);
    return null;
  }
};

/// PATCH
// Fonction pour modifier une mise à jour : updateUpdate
export const updateUpdateById = async (updateId, update) => {
  try {
    const response = await axios.patch(
      `${apiUrl}/updateUpdate/${updateId}`,
      update,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la modification du update:", error);
    return null;
  }
};

/// DELETE
// Fonction pour supprimer une mise à jour : deleteUpdateById
export const deleteUpdateById = async (updateId) => {
  try {
    const response = await axios.delete(`${apiUrl}/deleteUpdate/${updateId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression du update:", error);
    return null;
  }
};
